import { createContext } from 'react';

/**
 * Context to detect nested AppLayout mounts.
 * When AppLayout is rendered from the layout route, this is `true`.
 * If a page also wraps its content in <AppLayout>, it detects the
 * context and becomes a transparent pass-through (renders just children).
 * This is what eliminates the white flash — the layout route keeps
 * sidebar/header mounted, and per-page <AppLayout> is a no-op.
 *
 * Its own file since sideview: the side view's shell stands in for AppLayout
 * inside the panel, and must switch the same pass-through on.
 */
export const AppLayoutMountedContext = createContext(false);
